import { Grid } from "@mui/material";
import { IChequeCard } from "./IChequeCard";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export default function ChequeCard({ onClick, chequeInfo, index }: IChequeCard) {

    var x: { [key: number]: string } = {
        1: "اول",
        2: "دوم",
        3: "سوم",
        4: "چهارم",
        5: "پنجم",
        6: "ششم",
        7: "هفتم",
        8: "هشتم",
        9: "نهم",
        10: "دهم",
        11: "یازدهم",
        12: "دوازدهم",
        13: "سیزدهم",
        14: "چهاردهم",
        15: "پانزدهم",
        16: "شانزدهم",
        17: "هفدهم",
        18: "هجدهم",
        19: "نوزدهم",
        20: "بیستم",
        21: "بیست و یکم",
        22: "بیست و دوم",
        23: "بیست و سوم",
        24: "بیست و چهارم",
        25: "بیست و پنجم",
        26: "بیست و ششم",
        27: "بیست و هفتم",
        28: "بیست و هشتم",
        29: "بیست و نهم",
        30: "سی ام",
        31: "سی و یکم",
        32: "سی و دوم",
        33: "سی و سوم",
        34: "سی و چهارم",
        35: "سی و پنجم",
        36: "سی و ششم",
        37: "سی و هفتم",
        38: "سی و هشتم",
        39: "سی و نهم",
        40: "چهلم",
        41: "چهل و یکم",
        42: "چهل و دوم",
        43: "چهل و سوم",
        44: "چهل و چهارم",
        45: "چهل و پنجم",
        46: "چهل و ششم",
        47: "چهل و هفتم",
        48: "چهل و هشتم",
    };

    return (
        <>
            <Grid
                className='borderColorPrimaryColorLight-300'
                style={{
                    border: '1.5px solid ',
                    height: '80px',
                    // margin: 'auto',
                    borderRadius: '5px',
                    background: '#fff',
                    alignContent: 'center',
                    marginTop: '10px',
                }}
                container
                spacing={0}
                onClick={() => onClick!(chequeInfo.chequeId, index)}
            >
                <Grid container item spacing={0} xs={10} >

                    <div
                        style={{
                            display: 'flex',
                            marginRight: '20px',
                            alignSelf: 'center',
                            border: '1.5px solid ',
                            borderRadius: '5px',
                            width: "50px",
                            height: "50px",
                            borderColor: "#DAE0E4"
                        }}
                    >
                        {chequeInfo.frontImage?.fileUrl ? <img src={chequeInfo.frontImage.fileUrl} style={{ width: "inherit", height: "inherit", padding: "10px 0px 10px 0px" }} /> :
                            <div style={{
                                borderRadius: '5px',
                                background: '#F5F6FA',
                                height: '70%',
                                width: '100%',
                                alignSelf: "center"
                            }}>
                                <img
                                    style={{ margin: "0 auto" }}
                                    className="text-center block"
                                    src='/images/emptyImage.png'
                                />
                            </div>
                        }


                    </div>

                    <div style={{ display: 'inline-block', marginRight: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: "14px", fontStyle: "bold" }} className="text-sm  primaryColorLight-900">چک قسط {x[index + 1]}</span>
                            <span className="font-normal text-xs primaryColorLight-100" style={{ float: "right", fontSize: "12.5px" }}>
                                مبلغ  &nbsp; {chequeInfo.amount.toLocaleString()}  &nbsp;ریال &nbsp;- &nbsp;{chequeInfo.dueDatePersian}
                            </span>

                        </div>
                    </div>
                </Grid>
                <Grid item xs={2} className="leftSide" spacing={0}>
                    <MoreHorizIcon
                        className="primaryColorLight-100"
                        style={{ width: '24px', height: '24px' }}
                    />
                </Grid>
            </Grid>
        </>
    )
}